<script lang="ts">
import { reactive, defineComponent } from '@vue/composition-api';

interface IProps {
    value: boolean;
    dismissable: boolean;
}

const AppWarning = defineComponent({
    name: 'AppWarning',
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        dismissable: {
            type: Boolean,
            default: true,
        },
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        const onInput = (newVal: boolean) => {
            ctx.emit('input', newVal);
        };

        return {
            state,
            onInput,
        };
    },
});

export default AppWarning;
</script>
 
<template>
  <v-alert
    :value="value"
    color="#FF6700"
    border="left"
    icon="$fasExclamationTriangle"
    outlined
    text
    :dismissible="dismissable"
    @input="onInput"
  >
    <slot />
  </v-alert>
</template>

<style lang="scss" scoped></style>
